import React from "react";
import Navbar from "../components/Navbar";
import { motion } from "framer-motion";

const PrivacyPolicy = () => {
  const lastUpdated = "October 26, 2025";

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gray-50 py-16 px-4 mt-10">
        <div className="max-w-4xl mx-auto">
          <motion.h1
            className="text-3xl sm:text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-800 to-pink-500 mb-4 text-center"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
          >
            Privacy Policy
          </motion.h1>

          <p className="text-sm text-gray-500 text-center mb-8">Last updated: {lastUpdated}</p>

          <div className="bg-white rounded-2xl shadow-md p-6 space-y-6">
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-2">Introduction</h2>
              <p className="text-gray-600 leading-relaxed">
                HLC ("we", "us", "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or interact with our services.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Information We Collect</h3>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Personal information you provide (name, email, phone, company).</li>
                <li>Application and form data (career, dealer, contact forms).</li>
                <li>Transactional data (orders, billing, shipping) when you purchase.</li>
                <li>Technical data (IP address, device, browser, cookies) collected automatically.</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">How We Use Your Data</h3>
              <p className="text-gray-600 leading-relaxed">
                We use your information to provide and improve services, process orders and applications, communicate updates, prevent fraud, and comply with legal obligations. We may also use aggregated or anonymized data for analytics and product improvement.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Sharing & Disclosure</h3>
              <p className="text-gray-600 leading-relaxed">
                We may share your information with trusted service providers (payment processors, couriers, cloud providers) and as required by law. We do not sell personal data to third parties.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Security</h3>
              <p className="text-gray-600 leading-relaxed">
                We implement reasonable technical and organizational measures to protect your data. However, no system is completely secure — please take care when sharing sensitive information.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Retention</h3>
              <p className="text-gray-600 leading-relaxed">
                We retain personal information only as long as necessary for the purposes described, or as required by law.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Contact Us</h3>
              <p className="text-gray-600 leading-relaxed">
                For questions about this policy or your data, contact: <strong>privacy@hlc.com</strong> or your account manager.
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
